import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import '../styles/Header.css';
import { IMAGE_PATHS } from '../config/paths';
import { lang, setLang, getLang } from '../lang';

const routes = {
    es: {
        home: '/',
        projects: '/proyectos',
        team: '/equipo',
        contact: '/contacto'
    },
    en: {
        home: '/en/home',
        projects: '/en/projects',
        team: '/en/team',
        contact: '/en/contact'
    }
};

const Header: React.FC = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState(getLang());
    const location = useLocation();

    // Update language when route changes
    useEffect(() => {
        const newLang = getLang();
        if (newLang !== currentLanguage) {
            setCurrentLanguage(newLang);
        }
    }, [location.pathname]);

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const handleLanguageChange = () => {
        const newLang = currentLanguage === 'es' ? 'en' : 'es';
        setLang(newLang);
        setCurrentLanguage(newLang);
    };

    return (
        <header className="header">
            <div className="header-container">
                <div className="header-logo">
                    <img src={IMAGE_PATHS.LOGO} alt="Terral Logo" className="logo-img" />
                </div>
                <button className="mobile-menu-btn" onClick={toggleMenu}>
                    {isMenuOpen ? '✕' : '☰'}
                </button>
                <div className="header-en-btn-wrapper">
                    <button className="en-btn" onClick={handleLanguageChange}>
                        {lang.Header.en}
                    </button>
                </div>
                <nav className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
                    <button className="close-menu-btn" onClick={toggleMenu}>✕</button>
                    <ul>
                        <li><Link to={routes[currentLanguage].home} onClick={() => setIsMenuOpen(false)}>{lang.Header.home}</Link></li>
                        <li><Link to={routes[currentLanguage].projects} onClick={() => setIsMenuOpen(false)}>{lang.Header.projects}</Link></li>
                        <li><Link to={routes[currentLanguage].team} onClick={() => setIsMenuOpen(false)}>{lang.Header.team}</Link></li>
                        <li><Link to={routes[currentLanguage].contact} onClick={() => setIsMenuOpen(false)}>{lang.Header.contact}</Link></li>
                    </ul>
                </nav>
            </div>
        </header>
    );
};

export default Header; 